import { h, render } from 'preact'; /** @jsx h */
import { useEffect, useState } from 'preact/hooks';
import { Provider, useDispatch } from 'react-redux';
import store from './store';
import { optionsLagret } from './reducers/options';
import ShiftCalendarComponent from './components/ShiftCalendarComponent';
import {
    CheckBox,
    Slider,
    GenericDropdown
} from './global/generalComponentsInput';
import { GhostBtn } from './global/generalComponentsButtons';
import { getWidth } from './global/generalVariables';
import { offsetBasedOnWeek, getISOWeekNumber } from './global/dateVariables';
import './calendar-page.scss';

const version = window.snapshotcalendar;

const monthsAsText = [
    'Januar',
    'Februar',
    'Mars',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Desember'
];
const startYear = 2023;

const SnapshotCalendar = () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const [grabDataOnce, setGraber] = useState(false);
    const [jsonVakt, setJsonVakt] = useState([]);
    const [intervaler, setLainter] = useState(false);
    const [alleVakter, setAlleVakter] = useState([]);
    const [showMenu, setShowMenu] = useState(false);
    const [showHcm, setShowHcm] = useState(true);
    const [showPilot, setShowPilot] = useState(true);
    const [showLedige, setShowLedige] = useState(false);
    const [sliderView, setSliderView] = useState('NO');
    const [maxShow, setMaxShow] = useState(3);
    const [snapshot, setSnapshot] = useState({
        value: `month=${currentMonth + 1}&year=${currentYear}`,
        label: `${monthsAsText[currentMonth]} ${currentYear}`
    });
    const [snapshotOptions, setSnapshotOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        doResize();

        const snapshots = [];

        for (let y = startYear; y <= currentYear; y++) {
            let startMonthIndex = 0;
            // If we're in the start year, we might want to begin from a certain month
            if (y === startYear) startMonthIndex = 9; // Starting from September for example
            // If we're in the current year, we do not want to provide options beyond the current month
            const endMonthIndex = y === currentYear ? currentMonth : 11;

            for (let m = startMonthIndex; m <= endMonthIndex; m++) {
                snapshots.push({
                    label: `${monthsAsText[m]} ${y}`,
                    value: `month=${m + 1}&year=${y}`
                });
            }
        }
        setSnapshotOptions(snapshots);

        if (!grabDataOnce) {
            getSnapshotData();
            setGraber(true);
        }

        const resizeListener = () => {
            doResize();
        };
        window.addEventListener('resize', resizeListener);
        // clean up function
        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, []);

    const extract = (str, regex) => {
        const match = str.match(regex); // /year=(\d+)/

        return parseInt(match[1], 10);
    };

    /*
    useEffect(() => {
        let availableMonths = [];

        if (year.value === startYear && currentYear === startYear) {
            availableMonths = months.slice(8, currentMonth + 1);
        } else if (year.value === startYear) {
            availableMonths = months.slice(8);
        } else if (year.value > currentYear) {
            availableMonths = months;
        } else {
            availableMonths = months.slice(0, currentMonth + 1);
        }

        setMonthOptions(availableMonths);
    }, [year]);
    */

    useEffect(() => {
        if (grabDataOnce) {
            getSnapshotData();
        }
    }, [snapshot]); // month, year

    const versionControl = () => {
        if (
            document.scripts['snapshot-dash'].attributes['version'].value !==
            version
        ) {
            if (confirm('Det er en ny versjon ute, refresh siden?'))
                window.location.reload();
        }
    };

    useEffect(() => {
        if (!intervaler) {
            setInterval(() => {
                versionControl();
            }, 900000);
            setLainter(true);
        }
    }, []);

    useEffect(() => {
        let newVakter = jsonVakt;

        if (!showHcm) {
            newVakter = jsonVakt.filter((itm) => itm.crewkd !== 10);
        }
        if (!showPilot) {
            newVakter = newVakter.filter((itm) => itm.crewkd !== 20);
        }
        if (showLedige) {
            newVakter = newVakter.filter((itm) => itm.usid === 0);
        }

        setAlleVakter(newVakter);
    }, [showHcm, showPilot, showLedige]);

    const doResize = () => {
        const innerW = getWidth();
        let wds = innerW / 150;
        wds = parseInt(wds - 1);
        if (wds > 6) wds = 6; //grid doesn't really work with smaller values than 0.1%
        setMaxShow(wds);
    };

    const getSnapshotData = async () => {
        setIsLoading(true);
        const res = await fetch(
            `/api/getSnapshotdata.php?${snapshot.value}`, // month=${month.value}&year=${year.value}
            {
                method: 'post',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        const json = await res.json();
        if (json && json.schedule_vakt) {
            setJsonVakt(json.schedule_vakt);
            setAlleVakter(json.schedule_vakt);

            if (json && json.options) {
                dispatch(optionsLagret(json.options));
            }
        } else {
            setJsonVakt([]);
            setAlleVakter([]);
        }
        setIsLoading(false);
    };
    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };
    const changeCountry = (val) => {
        setSliderView(val.toUpperCase());
    };
    const countryVakter = (arr) => {
        return arr.filter((vakt) => vakt.land === sliderView);
    };

    return (
        <article
            id="calendar-page-dashboard"
            className={showMenu && !isLoading ? 'menu-shown' : 'hidden-menu'}
        >
            <div className="selected-crew-info">
                <CheckBox
                    id="ledige"
                    name="showledige"
                    label="Kun ledige"
                    checked={showLedige}
                    onChange={setShowLedige}
                />
                <fieldset>
                    <CheckBox
                        id="showHcmCheck"
                        name="showHcmCheck"
                        label="HCM"
                        checked={showHcm}
                        onChange={setShowHcm}
                    />
                    <CheckBox
                        id="showPilotCheck"
                        name="showPilotCheck"
                        label="Pilot"
                        checked={showPilot}
                        onChange={setShowPilot}
                    />
                </fieldset>
                <Slider
                    leftSide="NO"
                    rightSide="DK"
                    value={sliderView}
                    name="slide-calendar-country"
                    changeValue={changeCountry}
                />
                <GenericDropdown
                    label={'Velg øyeblikk'}
                    options={snapshotOptions}
                    selected={snapshot}
                    setSelected={setSnapshot}
                />
                <GhostBtn
                    label={showMenu ? 'X' : ''}
                    className="close-menupoint"
                    onClick={toggleMenu}
                >
                    {!showMenu && (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="white"
                            height="30"
                            viewBox="0 0 24 24"
                            width="30"
                        >
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
                        </svg>
                    )}
                </GhostBtn>
            </div>
            {isLoading ? (
                <p className="loader-container">
                    <div className="loader"></div>
                    Henter øyeblikksbilde: {snapshot.label}.
                </p>
            ) : (
                <ShiftCalendarComponent
                    vakter={countryVakter(alleVakter)}
                    dobbelvaktSchvid={[]}
                    dobbelpersonSchvid={[]}
                    minFilter
                    ignoreGoTo={true}
                    maxShow={maxShow}
                    filterAllChecked={true}
                    publicDash
                    zoomActive={true}
                    setMaxShow={setMaxShow}
                    offset={offsetBasedOnWeek(
                        getISOWeekNumber(
                            extract(snapshot.value, /month=(\d+)/) - 1,
                            extract(snapshot.value, /year=(\d+)/)
                        ) + 1,
                        extract(snapshot.value, /year=(\d+)/)
                    )}
                    snapshot
                />
            )}
        </article>
    );
};

render(
    <Provider store={store}>
        <SnapshotCalendar />
    </Provider>,
    document.getElementById('content')
);
